import fetchConfig from './config/fetch';
import './index.css';

import('./bootstrap');

const isDev = process.env.NODE_ENV === 'development';

if (isDev) {
  import('./Root');
} else {
  fetchConfig().then(() => {
    import('./Root');
  });
}
